import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=c343a562&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=c343a562&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c343a562",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c343a562')) {
      api.createRecord('c343a562', component.options)
    } else {
      api.reload('c343a562', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=c343a562&scoped=true", function () {
      api.rerender('c343a562', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/footer/Footer.vue"
export default component.exports